var map = {
	"./ar.svg": "d951",
	"./bo.svg": "fd19",
	"./br.svg": "ffca",
	"./cl.svg": "099a",
	"./co.svg": "0a29",
	"./cr.svg": "954d",
	"./ec.svg": "448d",
	"./mx.svg": "7b89",
	"./pe.svg": "da0a",
	"./us.svg": "06ca",
	"./uy.svg": "6fe6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a09a";